import React from 'react';

/**
 * 렌더 예외 격리 경계.
 * 자식 트리에서 throw 가 발생해도 상위 페이지가 통째로 흰 화면(언마운트)으로 죽지 않고,
 * 이 경계 안쪽만 fallback(기본: 아무것도 안 그림)으로 대체된다.
 *
 * BugHerd #240: 투어 부킹 옵션 데이터 이상(빈 설명/가격 등) 1건이 렌더 예외를 던지면
 *   에러 경계가 없던 탓에 페이지 상단 차량 이미지까지 함께 사라지던 현상을 차단한다.
 *   → 옵션 섹션만 이 경계로 감싸면 옵션이 깨져도 차량정보·일정·결제 영역은 정상 노출.
 *
 * props.fallback: 예외 시 렌더할 노드(미지정 시 null = 해당 영역만 비움).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // 원인 추적용 — 사용자 정보 노출 없이 스택만 콘솔에 남긴다.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info && info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback != null ? this.props.fallback : null;
    }
    return this.props.children;
  }
}
